module.exports = __webpack_public_path__ + "img/food.0ff8fdeb.svg";